import React from 'react';

interface Props {
	children: React.ReactElement | React.ReactElement[];
}

const SubscriptionPaymentWidgetWrapper: React.FC<Props> = ({ children }) => {
	return (
		<div className='row justify-content-center'>
			<div className='col-lg-4 col-12 mb-3'>{children}</div>
		</div>
	);
};

export default SubscriptionPaymentWidgetWrapper;
